export type PlanInterval = "monthly" | "yearly";

export const MONTHLY_PRICE_ID =
  process.env.REACT_APP_STRIPE_MONTHLY_SUBSCRIPTION_PRICE_ID || "";
export const YEARLY_PRICE_ID =
  process.env.REACT_APP_STRIPE_YEARLY_SUBSCRIPTION_PRICE_ID || "";

export interface BillingPlan {
  id: PlanInterval;
  name: string;
  price: number;
  priceLabel: string;
  interval: string;
  priceId: string;
  description: string;
  subtitle?: string;
  badge?: string;
  features: string[];
}

export const BILLING_PLANS: Record<PlanInterval, BillingPlan> = {
  monthly: {
    id: "monthly",
    name: "Monthly Plan",
    price: 197,
    priceLabel: "$197",
    interval: "/month",
    priceId: MONTHLY_PRICE_ID,
    description:
      "Perfect for beginners and freelancers exploring Retell AI's white label potential.",
    features: [
      "Full access to white label platform under your brand",
      "Seamless integration with your Retell Account",
      "Isolated resources per subaccount",
      "Separate billing logs for each subaccount",
    ],
  },
  yearly: {
    id: "yearly",
    name: "Yearly Plan",
    price: 1400,
    priceLabel: "$1,400",
    interval: "/year",
    priceId: YEARLY_PRICE_ID,
    description: "Save $964 with annual billing",
    subtitle: "",
    badge: "Save 41%",
    features: [
      "Everything in Monthly plan",
      "Save 41% compared to monthly",
      "Priority support",
      "Early access to new features",
    ],
  },
};

export function getPlanFromPriceId(
  priceId: string | null | undefined,
): PlanInterval | null {
  if (!priceId) return null;
  if (priceId === YEARLY_PRICE_ID) return "yearly";
  if (priceId === MONTHLY_PRICE_ID) return "monthly";
  return null;
}

export function getPlanDisplay(priceId: string | null | undefined): BillingPlan {
  const interval = getPlanFromPriceId(priceId);
  return interval ? BILLING_PLANS[interval] : BILLING_PLANS.monthly;
}

export function getPlanFromSubscriptionType(
  subscriptionType: string | null | undefined,
): PlanInterval | null {
  if (subscriptionType === "yearly" || subscriptionType === "monthly") {
    return subscriptionType;
  }
  return null;
}

export function getPlanDisplayFromSubscription(subscription: {
  subscription_type?: string | null;
  stripe_price_id?: string | null;
}): BillingPlan {
  const fromType = getPlanFromSubscriptionType(subscription.subscription_type);
  if (fromType) {
    return BILLING_PLANS[fromType];
  }
  return getPlanDisplay(subscription.stripe_price_id);
}
